/**
 * Deriva el nombre del continente en español a partir de los campos
 * region y subregion de Country State City.
 */

const subregionMap: Record<string, string> = {
  'South America': 'Sudamérica',
  'Northern America': 'Norteamérica',
  'Central America': 'Centroamérica y Caribe',
  'Caribbean': 'Centroamérica y Caribe',
};

const regionMap: Record<string, string> = {
  'Europe': 'Europa',
  'Africa': 'África',
  'Asia': 'Asia',
  'Oceania': 'Oceanía',
  'Americas': 'Américas',
  'Polar': 'Polar',
};

export function derivarContinente(region: string, subregion: string): string {
  return subregionMap[subregion] || regionMap[region] || region;
}
